import api from "./api";

export interface WaitlistJoinResponse {
  message: string;
}

export const joinWaitlist = async (email: string): Promise<WaitlistJoinResponse> => {
  try {
    // Direct call to the new endpoint
    const response = await api.post<WaitlistJoinResponse>("/waitlist", { email });
    return response.data;
  } catch (error) {
    console.error("Failed to join waitlist:", error);
    throw error;
  }
};
